import { render, staticRenderFns } from "./navicat.vue?vue&type=template&id=563d0b2e&scoped=true"
import script from "./navicat.vue?vue&type=script&lang=js"
export * from "./navicat.vue?vue&type=script&lang=js"
import style0 from "./navicat.vue?vue&type=style&index=0&id=563d0b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d0b2e",
  null
  
)

export default component.exports